// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04fd766e","382":"207d852b","453":"8f9190a2","455":"c8670d86","977":"3f9c1126"}[chunkId] + ".chunk.js";
};